<app-search-bar [filters]="filters" [showPrimaryBtn]="false"
  (formValueChange)="handleFormValueChange($event)"></app-search-bar>

<ng-container *ngIf="loadCampanhas; else SetData">
  <app-skeleton-loader [count]="5" type="card-campanha-dash"></app-skeleton-loader>
</ng-container>

<ng-template #SetData>
  <ng-container *ngIf="pagination.data?.length; else noData">
    <div class="list mt-3" *ngFor="let item of pagination.data">
      <app-card-campanha-dash-admin [campanha]="item.campanha" [codigo]="item?.campanha?.id"
        [titulo]="item?.campanha?.titulo" [Sector]="item?.campanha?.categoria?.descricao"
        [Objectivo]="item?.campanha?.metaArrecadar" [Arrecadado]="item?.campanha?.valorArrecado"
        [estado]="item?.campanha?.estadoCampanha" [DataCriacao]="item.dataCriacaoFormatada"
        [actions]="getActionsByEstado(item)" (rowClick)="verDetalhe(item)"
        (menuOpened)="setOpenedMenu($event)"></app-card-campanha-dash-admin>
    </div>

    <div class="pagination-controls">
      <app-paginator-control [first]="
          ((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)
        " [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
        (pageChange)="onPageChange($event)">
      </app-paginator-control>
    </div>
  </ng-container>
</ng-template>

<ng-template #noData>
  <div class="no-data">
    <app-data-void titulo="Nenhuma campanha encontrada" descricao="Tente novamente mais tarde."></app-data-void>
  </div>
</ng-template>

<p-drawer [(visible)]="visible" position="right" [style]="{ width: '780px', maxWidth: '95vw' }"
  styleClass="!w-full md:!w-80 lg:!w-[48.75rem]" appendTo="body" [blockScroll]="true" [modal]="true">
  <ng-template #headless>
    <div class="drawer-body-wrapper">
      @if (campanha?.campanha) {
      <app-admin-detalhe-campanha [campanha]="campanha?.campanha" (onCloseModal)="visible = false" />
      }
    </div>
  </ng-template>
</p-drawer>